/**
 * Phaser FIT-scale масштабирует canvas через CSS, но DOM-container
 * (для DOM input fields) остаётся в исходных пикселях — login/password
 * поля «уезжают» за края канваса. Эта функция выравнивает transform
 * DOM-контейнера с реальными размерами canvas.
 *
 * Вынесено отдельно из main.ts, чтобы сцены могли импортировать без
 * circular dependency.
 */
import type Phaser from "phaser";
import { GAME } from "../config";

let gameRef: Phaser.Game | null = null;

export function registerGame(game: Phaser.Game) {
  gameRef = game;
}

export function syncDomContainerScale() {
  if (!gameRef) return;
  const canvas = gameRef.canvas;
  if (!canvas || !canvas.parentElement) return;
  const rect = canvas.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return;
  const sx = rect.width / GAME.WIDTH;
  const sy = rect.height / GAME.HEIGHT;
  const parent = canvas.parentElement;
  for (let i = 0; i < parent.children.length; i++) {
    const node = parent.children[i] as HTMLElement;
    if (node.tagName === "CANVAS") continue;
    if (!node.style) continue;
    node.style.position = "absolute";
    node.style.left = `${canvas.offsetLeft}px`;
    node.style.top = `${canvas.offsetTop}px`;
    node.style.width = `${GAME.WIDTH}px`;
    node.style.height = `${GAME.HEIGHT}px`;
    node.style.transformOrigin = "top left";
    node.style.transform = `scale(${sx}, ${sy})`;
    node.style.pointerEvents = "none";
    const inputs = node.querySelectorAll("input, button, textarea, select, label");
    inputs.forEach(el => { (el as HTMLElement).style.pointerEvents = "auto"; });
  }
}

export function installDomScaleObserver(game: Phaser.Game) {
  registerGame(game);

  if (typeof window === "undefined") return;
  game.scale.on("resize", syncDomContainerScale);
  window.addEventListener("resize", syncDomContainerScale);

  const start = () => {
    const canvas = game.canvas;
    if (!canvas || !canvas.parentElement) {
      setTimeout(start, 50);
      return;
    }
    const observer = new MutationObserver(() => syncDomContainerScale());
    observer.observe(canvas.parentElement, { childList: true, subtree: true });
    syncDomContainerScale();
  };

  // Страховочные таймеры на boot (canvas/контейнер могут запоздать)
  setTimeout(syncDomContainerScale, 100);
  setTimeout(syncDomContainerScale, 500);
  setTimeout(syncDomContainerScale, 1500);
  start();
}
